import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=9b40cf04&scoped=true&"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts&"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=9b40cf04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b40cf04",
  null
  
)

export default component.exports